<template>
    <div class="wrapper" v-show="showModal">
        <div class="container">
            <div class="flex items-center gap-3 mb-3 w-full">
                <span class="arr_left" @click="close($event)">
                    <img src="../icons//arrow-left.svg" alt="message icon" class="w-6/12" />
                </span>
                <div class="flex items-center gap-2">
                    <span class="dispatcher_img">
                        <img :src="messageProps?.driver?.imageurl || shipping?.driver?.imageurl"
                            class="w-full rounded-full" />
                    </span>
                    <p class="text-sm leading-3">
                        <b class="disp_name">{{ `${(shipping?.driver?.first_name || "") ||
                            (messageProps?.driver?.firstname || "")}
                            ${(shipping?.driver?.last_name || "") || (messageProps?.driver?.lastname || "")}` }}</b>
                        <!-- <span class="text-xs opacity-50">Online</span> -->
                    </p>
                </div>
            </div>
            <hr />
            <div ref="chatContain" class="msg_disp">
                <NoMessageWidget :shipping="shipping" v-if="chatMessages.length < 1 && !loading" />
                <ChatMessages :chatMessages="chatMessages" v-if="chatMessages.length > 0 && !loading" />
            </div>
            <div class="w-full flex gap-3 items-center mt-3 sm:px-6">
                <div class="textarea_msg no_scroller">
                    <textarea ref="chatInput" @keydown.enter.exact.prevent="sendMessage" @keydown.shift.enter.stop
                        @focus="autoResize" @input="autoResize" v-model="message" rows="1" @blur="autoResize"
                        class="no_scroller" placeholder="Type your message..."></textarea>
                </div>
                <div>
                    <button :class="[canMessage ? 'opcity-100' : 'opacity-50']" @click="sendMessage"
                        class="btn_send_msg">
                        <img src="../icons/send_btn.svg" alt="message icon" class="w-8/12" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NoMessageWidget from './BookingActions/noMessageWidget.vue';
import { ChatService } from '../../../../services/socketFactory';
import ChatMessages from './BookingActions/ChatMessages.vue';

export default {
    name: "MessageModal",
    components: {
        NoMessageWidget,
        ChatMessages
    },
    props: {
        messageProps: {
            required: false,
        },
        showModal: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    data() {
        return {
            message: "",
            chatMessages: [],
            loading: false
        }
    },
    // apollo: {
    //     // Vue Apollo magic
    //     $subscribe: {
    //         newMessages: {
    //             query: this.$_GraphQL_Endpoint.getMessagesSub,
    //             variables() {
    //                 return { tripId: "68cd0b3dfe305054ce5f593d" } // 👈 your tripId
    //             },
    //             result({ data }) {
    //                console.log("data", data)
    //             }
    //         }
    //       }
    //     },
    watch: {
        shipping() {
            if (!this.messageProps?.tripId || !this.shipping?.tripId) return;
            this.showModal && this.getTripMessages()
            this.showModal && this.listenToMessage()
        },
        messageProps() {
            this.getTripMessages();
            ChatService.setupSocketConnection();
        },
        showModal(val) {
            console.log(">>>>>>>>>>>>>>>", this.messageProps)
            val && this.getTripMessages()
            val && ChatService.setupSocketConnection();
            val && this.listenToMessage()
            if (!val) {
                this.chatMessages = [];
                ChatService.disconnect();
                clearInterval(this.interval);
            }
        }
    },
    computed: {
        canMessage() {
            return this.message != '' && (this.messageProps?.tripId != undefined || this.shipping?.tripId != undefined)
        },
        shipping() {
            return this.$store.getters.newCurrentShipping || this.messageProps;
        },
    },
    methods: {
        autoResize(e) {
            const el = e?.target || this.$refs?.chatInput
            if (!el) return

            // Reset height to auto first
            el.style.height = "auto"

            // If there's content, expand to fit scroll height
            if (el.value) {
                el.style.height = el.scrollHeight + "px"
            } else {
                // If cleared, shrink back to 1 row height
                el.style.height = "1.5em"  // 1 line based on line-height
            }
        },
        groupMessages(messages) {
            const grouped = messages.reduce((acc, message) => {
                // Extract just the date (YYYY-MM-DD)
                const date = new Date(message.timestamp).toISOString().split("T")[0]

                if (!acc[date]) {
                    acc[date] = []
                }
                acc[date].push(message)

                return acc
            }, {})

            // If you want an array of arrays grouped by date:
            return Object.values(grouped)
        },
        async getTripMessages() {
            if (!this.messageProps?.tripId || !this.shipping?.tripId) return;

            this.loading = true;
            await this.$apollo
                .query({
                    query: this.$_GraphQL_Endpoint.getMessagesTrip,
                    variables: { tripId: this.messageProps?.tripId || this.shipping?.tripId },
                    fetchPolicy: 'no-cache'
                }).then((res) => {
                    // this.chatMessages = res.data.getMessages.data;
                    this.chatMessages = this.groupMessages(res.data.getMessages.data)
                    this.message = ""
                    setTimeout(() => {
                        this.scrollToBottom();
                    }, 200)
                }).finally(() => {
                    this.loading = false;
                })
        },
        async sendMessage() {
            if (!this.canMessage) return
            await this.$apollo
                .mutate({
                    mutation: this.$_GraphQL_Endpoint.sendMessage,
                    variables: {
                        tripId: this.messageProps?.tripId || this.shipping?.tripId,
                        senderId: this.$store.getters.user.id,
                        senderRole: "driver",
                        content: this.message
                    },
                }).then(() => {
                    this.message = "";
                    this.$refs?.chatInput?.blur();
                    setTimeout(() => {
                        this.$refs?.chatInput?.focus();
                    }, 50)
                })
        },
        listenToMessage() {
            const socketName = `messages::${this.messageProps?.tripId || this.shipping?.tripId}`
            this.interval = setInterval(() => {
                ChatService.getChatMessages(socketName).then((data) => {
                    this.chatMessages = this.groupMessages(data)
                    this.autoResize();
                    this.scrollToBottom();
                });
            }, 300);
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.chatContain;
                if (container) {
                    container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
                }
            });
        },
        close(e) {
            e.stopPropagation();
            this.$store.dispatch("saveNewCurrentShipping", {});
            this.$emit("close-modal");
        }
    }
}
</script>

<style lang="scss" scoped>
.arr_left {
    @apply w-6 h-6 bg-slate-200 rounded-md inline-flex justify-center items-center
}

.dispatcher_img {
    @apply w-8 h-8 rounded-full border-[1px] border-slate-300 overflow-hidden
}

.disp_name {
    @apply block w-full mb-[2px]
}

.container {
    @apply h-[90vh] max-h-[90vh] overflow-y-auto bg-white w-[96%] md:w-[900px] py-4 px-3 rounded-lg flex-col flex flex-wrap
}

.wrapper {
    @apply fixed top-0 left-0 w-full h-full bg-black-default bg-opacity-30 z-[999] flex justify-center items-center p-4
}

.msg_disp {
    @apply w-full h-[70%] overflow-y-auto;
    flex: 1;

    /* Hide scrollbar for Webkit browsers (Chrome, Safari, Edge) */
    &::-webkit-scrollbar {
        display: none;
    }

    /* Hide scrollbar for Firefox */
    scrollbar-width: none;

    /* Hide scrollbar for IE/Edge (legacy) */
    -ms-overflow-style: none;
}

.btn_send_msg {
    @apply w-9 h-9 rounded-full bg-primary-yellow inline-flex justify-center items-center;
}

.textarea_msg {
    @apply w-full rounded-lg p-2 py-1 border-[1px] border-gray-300;

    textarea {
        @apply w-full resize-none bg-transparent pt-[2px];
        max-height: calc(1.5em * 4);
        transition: 0.3s;
    }

    textarea::placeholder {
        color: black;
        opacity: 0.8;
        /* Make sure it's not faded on some browsers */
    }
}
</style>